<template>
  <div class="ispages">
    <!-- 运动消耗 -->
    <div class="consumption">
      <div class="consumption-items">
        <div class="list-main" v-for="(item, index) in exercise" :key="index">
          <img :src="item.url" alt="" />
          <div>{{ item.name }}{{ item.num }}分钟</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    netContent: Number,
  },
  data() {
    return {
      content: "",
      exercise: [
        {
          name: "走路",
          num: "0",
          url: require("../../../assets/imgs/walking.png"),
        },
        {
          name: "跑步",
          num: "0",
          url: require("../../../assets/imgs/running.png"),
        },
        {
          name: "游泳",
          num: "0",
          url: require("../../../assets/imgs/swimming.png"),
        },
        {
          name: "骑车",
          num: "0",
          url: require("../../../assets/imgs/Cycling.png"),
        },
        {
          name: "跳绳",
          num: "0",
          url: require("../../../assets/imgs/Jumping.png"),
        },
        {
          name: "篮球",
          num: "0",
          url: require("../../../assets/imgs/busketball.png"),
        },
        {
          name: "滑雪",
          num: "0",
          url: require("../../../assets/imgs/skiing.png"),
        },
        {
          name: "力量",
          num: "0",
          url: require("../../../assets/imgs/power.png"),
        },
        {
          name: "体操",
          num: "0",
          url: require("../../../assets/imgs/gymnastics.png"),
        },
      ],
    };
  },
  mounted() {
    this.calculateSpot();
  },
  methods: {
    //计算运动消耗
    calculateSpot() {
      let energyNum = parseInt(this.netContent * 0.2389);
      let arr = this.exercise.map((item) => {
        switch (item.name) {
          case "走路":
            item.num = parseInt((energyNum / 255) * 60);
            return item;
          case "跑步":
            item.num = parseInt((energyNum / 600) * 60);
            return item;
          case "游泳":
            item.num = parseInt((energyNum / 550) * 60);
            return item;
          case "骑车":
            item.num = parseInt((energyNum / 415) * 60);
            return item;
          case "跳绳":
            item.num = parseInt((energyNum / 660) * 60);
            return item;
          case "篮球":
            item.num = parseInt((energyNum / 500) * 60);
            return item;
          case "滑雪":
            item.num = parseInt((energyNum / 600) * 60);
            return item;
          case "力量":
            item.num = parseInt((energyNum / 300) * 60);
            return item;
          case "体操":
            item.num = parseInt((energyNum / 350) * 60);
            return item;
        }
      });
      this.exercise = arr;
    },
  },
};
</script>

<style lang="less" scoped>
.ispages {
  padding: 10px;
  padding-bottom: 25px;
  background: #fff;
  box-sizing: border-box;
  font-family: "HarmonyOS Sans SC-Regular, HarmonyOS Sans SC";
}
// 运动消耗
.consumption {
  &-items {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .list-main {
      min-width: 90px;
      height: 46px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      margin-top: 16px;
      img {
        width: 24px;
        height: 24px;
      }
      div {
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        line-height: 30px;
      }
    }
  }
}
</style>